import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import Image from 'src/components/Image';
import RichText from '../RichText';
import DownloadCv from './DownloadCv';

const BioPhotos = function ({ photos }) {
  return (
    <div className='bio-photos'>
      {map(photos, (photo) => (
        <Image
          src={photo.url}
          preview={false}
          key={photo.url}
          className='bio-photos__photo'
          {...photo}
        />
      ))}
    </div>
  );
};

BioPhotos.propTypes = {
  photos: PropTypes.array.isRequired,
};

const AboutMobile = function ({
  bioDownload,
  paragraphCareer,
  paragraphCooperation,
  paragraphEducation,
  photosCareer,
  photosEdu,
}) {
  return (
    <>
      <RichText text={paragraphEducation} />
      <BioPhotos photos={photosEdu} />
      <RichText text={paragraphCareer} />
      <BioPhotos photos={photosCareer} />
      <RichText text={paragraphCooperation} />
      <DownloadCv bioDownload={bioDownload} />
    </>
  );
};

AboutMobile.propTypes = {
  bioDownload: PropTypes.array.isRequired,
  paragraphCareer: PropTypes.object.isRequired,
  paragraphCooperation: PropTypes.object.isRequired,
  paragraphEducation: PropTypes.object.isRequired,
  photosCareer: PropTypes.object.isRequired,
  photosEdu: PropTypes.array.isRequired,
};

export default AboutMobile;
